(function () {
  'use strict';

  var el = document.getElementById('preloader');

  /* Bail if overlay not in DOM (design mode, or skip class already hid it) */
  if (!el) return;

  /* ── Session flag ─────────────────────────────────────────────────────────
     Set immediately so any navigation away from this page — even mid-load —
     will skip the loader on the next page. */
  try { sessionStorage.setItem('pl_shown', '1'); } catch (e) {}

  var video        = document.getElementById('preloader-video');

  /* ── Timing constants ─────────────────────────────────────────────────────
     ANIM_DURATION_MS  = fallback delay when no video element exists
     SAFETY_MS         = hard cap in case video stalls / autoplay is blocked
     FADE_DURATION_MS  = must match CSS transition-duration on #preloader     */
  var ANIM_DURATION_MS  = 3000;
  var SAFETY_MS         = 5000;
  var FADE_DURATION_MS  = 600;

  var pageReady = false;
  var animDone  = false;
  var dismissed = false;

  /* ── Dismiss ──────────────────────────────────────────────────────────────
     Both conditions must be true before the overlay fades out:
       1. window.load has fired (page fully loaded)
       2. animation timer / video ended event has fired                       */
  function dismiss() {
    if (dismissed || !pageReady || !animDone) return;
    dismissed = true;

    /* Restore body scroll (locked by inline script in preloader.liquid) */
    document.documentElement.style.overflow = '';

    /* Trigger CSS fade */
    el.classList.add('preloader--hidden');

    /* Remove element from DOM after fade completes */
    var cleanup = function () {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    el.addEventListener('transitionend', cleanup, { once: true });
    /* Safety: clean up even if transitionend never fires */
    setTimeout(cleanup, FADE_DURATION_MS + 150);
  }

  /* ── Page load listener ───────────────────────────────────────────────────
     If window.load already fired before this script ran, set flag directly. */
  if (document.readyState === 'complete') {
    pageReady = true;
  } else {
    window.addEventListener('load', function () {
      pageReady = true;
      dismiss();
    }, { once: true });
  }

  /* ── Animation timing ────────────────────────────────────────────────────
     Always play the preloader video — it is content, not decoration.
     Safety timeout caps the max wait if video stalls or autoplay is blocked. */
  if (video) {
    /* Video ended naturally */
    video.addEventListener('ended', function () {
      animDone = true;
      dismiss();
    }, { once: true });

    /* Safety: dismiss if video stalls, autoplay is blocked, or never fires ended */
    setTimeout(function () {
      animDone = true;
      dismiss();
    }, SAFETY_MS);

    /* Explicitly call play() to handle browsers that ignore the autoplay attribute */
    var playAttempt = video.play();
    if (playAttempt !== undefined) {
      playAttempt.catch(function () {
        /* Autoplay blocked — safety timeout above will still dismiss the loader */
      });
    }

  } else {
    /* No video element in DOM — fall back to timer */
    setTimeout(function () {
      animDone = true;
      dismiss();
    }, ANIM_DURATION_MS);
  }

}());
